/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `notSent` - Niewysłane
 * * `pending` - Oczekuje
 * * `inProgress` - Wysyłanie
 * * `completed` - Zakończone
 * * `completedWithErrors` - Zakończone z błędami
 * * `transportDisabled` - Transport niedostępny
 * * `failed` - Niepowodzenie
 * * `cancelled` - Anulowane
 */
export type NotificationStatusEnum = typeof NotificationStatusEnum[keyof typeof NotificationStatusEnum];


export const NotificationStatusEnum = {
  notSent: 'notSent',
  pending: 'pending',
  inProgress: 'inProgress',
  completed: 'completed',
  completedWithErrors: 'completedWithErrors',
  transportDisabled: 'transportDisabled',
  failed: 'failed',
  cancelled: 'cancelled',
} as const;
